define([
    "jquery",
    "models/product",
    "models/order",
    "utils/analytics"
    ], function($, ProductModel, OrderModel, Analytics) {
        "use strict";

        return App.View.extend({
            el: "body",

            events: {
                "click .js-pagination-quotes"    : "paginateQuotes",
                "click .js-product-minus"        : "decrementUnits",
                "click .js-product-plus"         : "incrementUnits",
                "click .js-shop-buy-button"      : "buy",
                "click .js-shop-goto-buy-button" : "goTobuy",
                "click .js-header-buy"           : "goTobuy"
            },

            initialize: function() {
                this.product = new ProductModel({
                    html: this.$el.find(".js-product")
                }, { parse: true });
            },

            buy: function() {
                this.model = new OrderModel();
                this.model.set("lines.0.id", this.product.get("id"));
                this.model.set("lines.0.tax",  this.product.get("tax"));
                this.model.set("lines.0.product_name",  this.product.get("name"));
                this.model.set("lines.0.price",  this.product.get("price"));
                this.model.set("lines.0.type", 4);
                this.model.set("lines.0.units", 1);

                this.model.tempSave();

                Analytics.trackAddToCart(this.model.get("lines")[0]);
            }
        });
    });
